import { uuid4 } from "@helpers/crypto/crypto";
import { bindable } from "aurelia";
import tippy, { roundArrow } from "tippy.js";
import 'tippy.js/dist/svg-arrow.css';
export class TooltipComponent {
  @bindable private labelText: string;
  private tooltipId: string = uuid4();

  attached() {
    tippy(document.getElementById(this.tooltipId), {
      content: this.labelText,
      theme: 'copymagico',
      arrow: roundArrow,
    })
  }
}